import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-shop-card-skeleton',
  standalone: true,
  templateUrl: './shop-card-skeleton.component.html',
  styleUrls: ['./shop-card-skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShopCardSkeletonComponent {}
